import { render } from "./NameAndTitle.vue?vue&type=template&id=e8e460c4&scoped=true"
import script from "./NameAndTitle.vue?vue&type=script&lang=js"
export * from "./NameAndTitle.vue?vue&type=script&lang=js"

import "@/Common/Styles/NameAndTitle.scss?vue&type=style&index=0&id=e8e460c4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e460c4"]])

export default __exports__